import React, { useEffect, useRef, useState } from 'react';
import Modal from '../../../../../../components/Modal';
import Table from '../../../../../../components/_table/Table/Table';
import Button from '../../../../../../components/Button';
import useTagListModal from '../hooks/useTagListModal';
import { columns } from '../columns';
import { TableOption } from '../types';
import { TagItem } from '../../../types';
import { INITIAL_OPTION_MODEL } from '../constants';
import { ProductAndTagListModalStyle } from '../../common/style';

type NormalizedTagList = {
  [key: string]: TagItem;
};

interface TagListModalProps {
  closeModal: () => void;
  selectedTagIdList: number[];
  onSubmit: (value: TagItem[]) => void;
  getRelatedTagList: (data: { tagId: number }) => void;
}
const TagListModal = (props: TagListModalProps) => {
  const { closeModal, selectedTagIdList, onSubmit, getRelatedTagList } = props;
  const [checkedIdList, setCheckedIdList] = useState<number[]>([]);
  const [tableOption, setTableOption] = useState<TableOption>(INITIAL_OPTION_MODEL);
  const { filterOption, pagination } = tableOption;
  const { data } = useTagListModal(tableOption, selectedTagIdList);
  const cachedTagList = useRef<NormalizedTagList>({});

  // 이미 선택된 태그, 태그 리스트 모달 체크리스트에 중복 제거하여 추가
  useEffect(() => {
    setCheckedIdList((prev) => [...new Set([...prev, ...selectedTagIdList])]);
  }, [selectedTagIdList]);

  // 한번이라도 체크된 모든 태그 정보를 캐싱하는 함수
  const setCachedTagList = (checkedList: number[]) => {
    if (!data?.tagList) return;

    const checkedIdListSet = new Set(checkedList);

    cachedTagList.current = {
      ...cachedTagList.current,
      ...Object.fromEntries(data.tagList.filter(({ id }) => checkedIdListSet.has(id)).map((item) => [item.id, item])),
    };
  };

  const resetOption = () => {
    setTableOption(INITIAL_OPTION_MODEL);
  };

  const handleCheck = (checkedList: number[]) => {
    setCheckedIdList(checkedList);
    setCachedTagList(checkedList);
  };
  const handleSubmit = () => {
    if (!data?.tagList) return;
    const selectedTagIdListSet = new Set(selectedTagIdList);

    onSubmit(checkedIdList.filter((id) => !selectedTagIdListSet.has(id)).map((id) => cachedTagList.current[id]));
    closeModal();
  };

  return (
    <Modal
      title="태그 리스트"
      isOpen={true}
      width={1200}
      height={687}
      isFooter={true}
      onOk={handleSubmit}
      onClose={() => closeModal()}
    >
      <ProductAndTagListModalStyle>
        <div className="summary">
          <span className="total-cnt">
            <span className="cnt">{data!.totalCount}</span>건이 조회되었습니다.
          </span>

          <div className="button-group">
            <Button isRadius color="primary" text="필터 초기화" onClick={resetOption} />
          </div>
        </div>
        <Table
          rowKey={(record: TagItem) => record.id}
          columns={(utils: any) => columns({ ...utils, getRelatedTagList })}
          list={data!.tagList}
          size="middle"
          bordered={true}
          onCheck={handleCheck}
          selectedList={checkedIdList}
          getList={(data: TableOption) => {
            setTableOption({
              ...tableOption,
              ...data,
            });
          }}
          pagination={{
            ...pagination,
            totalCnt: data!.totalCount,
          }}
          filterOption={filterOption}
        />
      </ProductAndTagListModalStyle>
    </Modal>
  );
};

export default TagListModal;
